import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, first, filterType, opened, isSomethingSelected }) => ({
    [theme.breakpoints.up('lg')]: {
        width: '20%',
        position: 'relative'
    },

    '& .FilterTrigger, & .Option': {
        display: 'flex',
        padding: '20px 40px',
        width: '100%'
    },

    '& .FilterTrigger': {
        borderBottom: `1px solid ${theme.colors.blueMid}`,
        borderTop: first ? `1px solid ${theme.colors.blueMid}` : null,
        position: 'relative',
        zIndex: 99,
        alignItems: 'center',

        [theme.breakpoints.up('lg')]: {
            borderBottom: 'none',
            borderTop: 'none',
            borderLeft: first ? null : `1px solid ${theme.colors.blueDark}`,
            padding: '40px 20px',
            height: '100%'
        },

        [theme.breakpoints.up('1460')]: {
            padding: '60px 30px'
        },

        [theme.breakpoints.up('xxl')]: {
            padding: '60px 40px'
        },

        '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: 2,
            height: '100%',
            background: isSomethingSelected ? theme.colors.goldDark : null,

            [theme.breakpoints.up('lg')]: {
                top: 'auto',
                bottom: 0,
                width: '100%',
                height: 2
            }
        }
    },

    '& .FilterIcon': {
        width: filterType === 'condition' ? 17 : 19,
        lineHeight: '0'
    },

    '& .FilterTitleSubtitle': {
        marginLeft: 20
    },

    '& .FilterTitle': {
        display: 'block',
        textAlign: 'left',
        textTransform: 'uppercase',
        fontSize: toRem(12),
        fontWeight: theme.typography.fontWeight.medium,
        color: theme.colors.goldDark,
        letterSpacing: 1,

        [theme.breakpoints.up('lg')]: {
            textTransform: 'none'
        },

        [theme.breakpoints.up('xl')]: {
            fontSize: toRem(14)
        },

        [theme.breakpoints.up('xxl')]: {
            fontSize: toRem(14)
        }
    },

    '& .FilterSubtitle': {
        display: 'none',

        [theme.breakpoints.up('lg')]: {
            textAlign: 'left',
            display: 'block',
            fontSize: toRem(12),
            color: theme.colors.white
        },

        [theme.breakpoints.up('xxl')]: {
            fontSize: toRem(16)
        }
    },

    '& .FilterArrow': {
        width: 16,
        marginLeft: 'auto',
        marginTop: -5,
        transition: 'transform 0.5s ease',
        transform: opened ? 'rotate(180deg)' : null,
        lineHeight: 0,

        path: {
            stroke: theme.colors.white,
            strokeWidth: 2
        }
    },

    '& .FilterOptions': {
        position: 'relative',
        zIndex: 9,
        [theme.breakpoints.up('lg')]: {
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '100%',
            borderTop: `1px solid ${theme.colors.blueDark}`,
            overflowX: 'auto',
            maxHeight: 'calc(100vh - 76px)'
        },
        [theme.breakpoints.up('xxl')]: {
            maxHeight: 'calc(100vh - 86px)'
        }
    },

    '& .Option': {
        justifyContent: 'space-between',
        background: theme.colors.blueLight,
        borderBottom: `1px solid ${theme.colors.blueMid}`,
        color: theme.colors.white,
        fontSize: toRem(14),
        whiteSpace: 'nowrap',

        [theme.breakpoints.up('lg')]: {
            padding: 20
        },

        [theme.breakpoints.up('xl')]: {
            padding: '20px 30px'
        },

        [theme.breakpoints.up('xxl')]: {
            padding: '20px 40px'
        },

        '&.is-featured': {
            color: theme.colors.gold,
            '&+:not(.is-featured)': {
                borderTop: `1px solid ${theme.colors.gold}`
            }
        }
    }
})

export default style
